var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-unstyled articles"},_vm._l((_vm.hierarchy(_vm.textNotes)),function(note){return _c('TextNoteExtract',{key:note.id,staticClass:"n-text-bold",attrs:{"type":"movement","note":note}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }